import { useEffect } from 'react'

/**
 * This component's full job is to make tesla testing on local more smooth
 * It assumes your .env on the backend has
 * TESLA_FLEET_REDIRECT_URI=https://staging.optiwatt.com/tesla-authentication-local
 */
function StagingToLocalTeslaRedirectBase(props: { redirectPath: string }) {
  // Redirect to localhost:3000/tesla-authentication with all the existing params
  useEffect(() => {
    const url = new URL(window.location.href)
    const redirectUrl = `https://localhost:3000${props.redirectPath}${url.search}`
    window.location.href = redirectUrl
  }, [])

  return null
}

export function StagingToLocalTeslaRedirect() {
  return (
    <StagingToLocalTeslaRedirectBase redirectPath="/tesla-authentication" />
  )
}

export function StagingToLocalTeslaEnergySystemRedirect() {
  return (
    <StagingToLocalTeslaRedirectBase redirectPath="/tesla-authentication/energy-system" />
  )
}
